import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import codes from "./codes";
import { setCRT } from "../actions";

class CRT extends React.Component {
  constructor(props) {
    super(props);
    this._onSelect = this._onSelect.bind(this);
  }
  _onSelect(e) {
    this.props.setCRT(e.value);
  }

  render() {
    const { loading, crt } = this.props;
    return (
      <div className="py-2">
        CRT
        <Select
          onChange={this._onSelect}
          placeholder="Selecione o CRT"
          isDisabled={loading}
          options={codes}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  crt: state.crt,
  loading: state.loading,
});
const mapDispatchToProps = (disptach) =>
  bindActionCreators({ setCRT }, disptach);
export default connect(mapStateToProps, mapDispatchToProps)(CRT);



// WEBPACK FOOTER //
// ./src/components/parts/person/personAdaptToCompany/crt/index.jsx